import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import { useGetUserSession } from '@/shared/hooks/api/auth'
import type { StandardApplicabilityDiscoveryTaskState } from '../utils/standardApplicabilityDiscoveryTaskState'
import { StandardApplicabilityDiscoveryProgress } from './StandardApplicabilityDiscoveryProgress'

type OnboardingStandardsDiscoveryStepProps = {
  standardsDiscoveryTaskState: StandardApplicabilityDiscoveryTaskState
  standardsWorkflowError: string | null
  onCancel: () => void
}

export function OnboardingStandardsDiscoveryStep({
  standardsDiscoveryTaskState,
  standardsWorkflowError,
  onCancel,
}: OnboardingStandardsDiscoveryStepProps) {
  const { t } = useTranslation('machineryDirectiveCompliance')
  const { data: session } = useGetUserSession()
  const showAdminCancel = session?.isArtemAdmin === true

  return (
    <>
      <div className='w-full max-w-lg space-y-4'>
        <h2 className='text-lg font-semibold tracking-tight'>
          {t('onboarding.standardApplicabilityDiscovery.heading')}
        </h2>
        <StandardApplicabilityDiscoveryProgress
          state={standardsDiscoveryTaskState}
        />
        {showAdminCancel && (
          <Button type='button' variant='outline' size='sm' onClick={onCancel}>
            {t('onboarding.adminCancelWorkflow')}
          </Button>
        )}
      </div>
      {standardsWorkflowError && (
        <p className='mt-8 text-center text-sm text-destructive' role='alert'>
          {standardsWorkflowError}
        </p>
      )}
    </>
  )
}
